<template>
    <storefront-node :storefront-prefix="storefrontPrefix" />
</template>

<script setup lang="ts">
import StorefrontNode from '~/components/Storefront/StorefrontNode.vue'
import { useActiveFacility } from '~/composables/use-active-facility'
import { computed, inject } from 'vue'

const storefrontPrefix = inject('STOREFRONT_PREFIX')
</script>
